import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from './auth.service';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private inj: Injector, private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authService = this.inj.get(AuthService);
    const url = req.url;
    
    // Skip adding token for login/auth endpoints
    const isAuthEndpoint = url.indexOf('/auth/login') > -1 || 
                          url.indexOf('/auth/') > -1 ||
                          url.indexOf('/password') > -1;
    
    // Prepare headers to set
    const headers: { [key: string]: string } = {};
    
    // Set Accept header to only application/json (remove text/plain, */*)
    // This matches the live environment behavior
    headers['Accept'] = 'application/json';
    
    // Get token and add Authorization header if user is logged in and not an auth endpoint
    if (!isAuthEndpoint && authService.isLoggedIn()) {
      const token = authService.getAccessToken();
      const tokenType = localStorage.getItem('token_type') || 'Bearer';
      
      if (token) {
        headers['Authorization'] = `${tokenType} ${token}`;
      }
    }
    
    // Clone request with updated headers
    const authReq = req.clone({
      setHeaders: headers
    });
    
    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          if (error.error && error.error.errors && error.error.errors[0] && error.error.errors[0].code && error.error.errors[0].code === 'code.subscription') {
            window.location.href = '/payment';
          }
        }

        if (error.status === 422) {
          if (error.error && error.error.errors && error.error.errors[0] && error.error.errors[0].code && error.error.errors[0].code === 'code.expired') {
            window.location.href = '/subscription/plan';
          }
        }

        // Handle 401 errors - only redirect if user was logged in and it's not a login attempt
        if (error.status === 401) {
          // Don't redirect on 401 during login attempts
          if (isAuthEndpoint) {
            return throwError(error);
          }
          
          // If user was logged in, session expired
          if (authService.isLoggedIn()) {
            authService.removeLocalStorage();
            window.location.href = '/login?sessionExpired=true';
          } else if (url.indexOf('member') > 0) {
            // If trying to access member area without being logged in
            authService.removeLocalStorage();
            window.location.href = '/login?sessionExpired=true';
          }
        }

        return throwError(error);
      })
    );
  }
}
